import styled from 'styled-components';

const SimpleMenuItemContainer = styled.div`
  vertical-align: middle;
  padding: 10px;
  margin: 10px 15px;

  p {
    font-family: Sofia Pro;
    font-size: 17px;
    line-height: 23px;
    color: var(--normal-title-color);
    margin: 0;
    padding: 0 10px;
    align-self: center;
  }

  img {
    width: 40px;
    height: 40px;
    min-width: 40px;
    border: none;
  }

  a {
    display: flex;
  }

  &:hover {
    background: var(--blue-fourth);
  }

  @media (max-width: 1240px) {
    width: 100%;
    height: auto;
    max-height: 100%;
    margin: 0 16px;

    img {
      width: 40px;
      height: 40px;
      min-width: 40px;
    }

    p {
      font-size: 16px;
      line-height: 28px;
    }

    &:hover {
      background: transparent;

      p {
        color: var(--neutral-text-color);
      }
    }
  }
`;

export { SimpleMenuItemContainer };
